import * as core from '../../../../../../../core'

import { query } from './save-risk-assessment.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.save-risk-assessment',
    description: 'Save Risk Assessment',
    name: 'Save Risk Assessment',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
